import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { ApiService } from './api.service';
import { IApiHealthStatus } from '../../interfaces/IAppHealthStatus.interface';

@Injectable({
  providedIn: 'root',
})
export class ApiHealthRestService {
  private readonly HEALTH_RESSOURCE: string = 'health';
  private _apiService: ApiService = inject(ApiService);

  public async getHealth(): Promise<IApiHealthStatus> {
    return await firstValueFrom(
      this._apiService.get<IApiHealthStatus>(this.HEALTH_RESSOURCE),
    );
  }
}
